function isQueryEntitiesInitialRequest(request) {
  return !request.cursor;
}

export { isQueryEntitiesInitialRequest };
//# sourceMappingURL=utils.esm.js.map
